import styled, {css} from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledBudgetPreview = styled(Space)`
  font-size: 14px;
  width: 100%;

  .ant-progress {
    display: flex;
    height: 6px;
  }

  .ant-progress-inner {
    border-radius: 100px !important;
  }
`;

const StyledBudgetPreviewOverBudgetTag = styled.span`
  ${typographyStyles.footnote.description};
  background-color: ${props => props.theme.colors.danger_100};
  color: ${props => props.theme.colors.danger_600};
  border-radius: 16px;
  display: inline-block;
  line-height: 24px;
  padding: 0 8px;
  text-wrap: nowrap;
`;

const StyledBudgetPreviewMatchedTag = styled(Space)`
  ${typographyStyles.footnote.description};
  border-radius: 16px;
  height: 24px;
  padding: 0 8px;
  width: auto !important;

  & > .ant-space-item {
    display: flex;
  }

  ${props => props.status === 'recommended' && css`
    background-color: #D6FFCE;
    color: #245F07;

    .ant-space-item {
      & > svg {
        path {
          stroke: #245F07;
        }
      }
    }
  `};

  ${props => props.status === 'review' && css`
    background-color: #F3F3F4;
    color: #515A6B;

    .ant-space-item {
      & > svg {
        path {
          stroke: #515A6B;
        }
      }
    }
  `};
`;

const StyledBudgetPreviewMatchedTagTooltip = styled.div`
  ${typographyStyles.footnote.description};

  min-width: 100px;

  .match-tag {
    align-items: center;
    display: flex;
    justify-content: space-between;

    svg {

    }
  }
`;

export {
  StyledBudgetPreview,
  StyledBudgetPreviewOverBudgetTag,
  StyledBudgetPreviewMatchedTag,
  StyledBudgetPreviewMatchedTagTooltip
}
